module.exports = __webpack_public_path__ + "static/media/Global.07a89b6a.svg";